// @flow

import React from 'react'
import ButtonBase from './Base'

function getButton(props) {
  switch (props.buttonType) {
    case 'largeFull':
      return (
        <ButtonBase fullWidth buttonHeightPc={48} fontSizePc={16} {...props}>
          {props.children}
        </ButtonBase>
      )
    case 'large':
      return (
        <ButtonBase
          buttonWidthPc={280}
          buttonHeightPc={48}
          fontSizePc={16}
          {...props}
        >
          {props.children}
        </ButtonBase>
      )
    case 'medium_2':
      return (
        <ButtonBase
          buttonWidthPc={180}
          buttonHeightPc={40}
          fontSizePc={16}
          {...props}
        >
          {props.children}
        </ButtonBase>
      )
    case 'medium':
      return (
        <ButtonBase
          buttonWidthPc={160}
          buttonWidthSp={140}
          buttonHeightPc={40}
          fontSizePc={16}
          fontSizeSp={14}
          {...props}
        >
          {props.children}
        </ButtonBase>
      )
    case 'medium_0':
      return (
        <ButtonBase
          buttonWidthPc={120}
          buttonHeightPc={40}
          fontSizePc={14}
          {...props}
        >
          {props.children}
        </ButtonBase>
      )
    case 'mediumFull':
      return (
        <ButtonBase fullWidth buttonHeightPc={40} fontSizePc={14} {...props}>
          {props.children}
        </ButtonBase>
      )
    case 'small':
      return (
        <ButtonBase
          buttonWidthPc={180}
          buttonHeightPc={30}
          buttonHeightSp={40}
          fontSizePc={12}
          fontSizeSp={13}
          {...props}
        >
          {props.children}
        </ButtonBase>
      )
    case 'tiny':
      return (
        <ButtonBase
          buttonWidthPc={120}
          buttonHeightPc={30}
          buttonHeightSp={40}
          fontSizePc={12}
          fontSizeSp={13}
          {...props}
        >
          {props.children}
        </ButtonBase>
      )
    case 'largeFull':
      return (
        <ButtonBase
          fullWidth
          buttonHeightPc={50}
          buttonHeightSp={40}
          fontSizePc={20}
          fontSizeSp={16}
          {...props}
        >
          {props.children}
        </ButtonBase>
      )
    case 'smallFull':
      return (
        <ButtonBase
          fullWidth
          buttonHeightPc={30}
          buttonHeightSp={40}
          fontSizePc={12}
          fontSizeSp={13}
          {...props}
        >
          {props.children}
        </ButtonBase>
      )
    case 'onlyIcon':
      return (
        <ButtonBase
          buttonWidthPc={30}
          buttonWidthSp={40}
          buttonHeightPc={30}
          buttonHeightSp={40}
          fontSizePc={13}
          fontSizeSp={14}
          {...props}
        >
          {props.children}
        </ButtonBase>
      )
    case 'onlyIconLarge':
      return (
        <ButtonBase
          buttonWidthPc={40}
          buttonHeightPc={40}
          fontSizePc={14}
          {...props}
        >
          {props.children}
        </ButtonBase>
      )
    case 'onlyBorderFullWidth':
      return (
        <ButtonBase
          fontSizePc={14}
          fontWeight
          fullWidth
          isOnlyBorder
          {...props}
        >
          {props.children}
        </ButtonBase>
      )
    default:
      return <ButtonBase {...props}>{props.children}</ButtonBase>
  }
}

export default (props: PropTypes) => getButton(props)
